import api from './api.service';

const aiService = {
  // Extract company information from URL
  extractCompanyInfo: async (url) => {
    try {
      const response = await api.post('/ai/extract-company-info', { url });
      return response.data;
    } catch (error) {
      console.error('Error extracting company info:', error);
      throw error;
    }
  },

  // Generate job description
  generateJobDescription: async (jobData) => {
    try {
      const response = await api.post('/ai/generate-job-description', jobData);
      return response.data;
    } catch (error) {
      console.error('Error generating job description:', error);
      throw error;
    }
  },

  // Generate media content
  generateMediaContent: async (mediaData) => {
    try {
      const response = await api.post('/ai/generate-media-content', mediaData);
      return response.data;
    } catch (error) {
      console.error('Error generating media content:', error);
      throw error;
    }
  }
};

export default aiService; 